import React, { useContext, useState,useEffect } from "react";
import { formatCurrency } from "../../utils";
import { SpinnerContext } from "../../components/spinner/spinner.component";
import { useHistory } from "react-router-dom";



const TopUpRechargeModel = ({
  isOpen,
  propertydata,
  redirectUrl,
  onCancel
}) => {
    const {ppcPerClickPrice,id,facilityType} = propertydata || {}
    const minValue = ppcPerClickPrice
    const maxValue = ppcPerClickPrice*50
    const history = useHistory();

    const [rechargeAmount, setRechargeAmount] = useState(null);
    const [errorMessage, setErrorMessage] = useState("");
    const {setsubscribePlanType,setsubscribePlanId } = useContext(SpinnerContext);
    

    useEffect(() => {
      if (minValue && rechargeAmount === null) {
        setRechargeAmount(minValue);
      }
    }, [minValue, rechargeAmount]);

  if (!isOpen)  return null;

  const handleChange = (e) => {
    const value = e.target.value;
    setRechargeAmount(value);

    // Reset error message when user changes the input
    setErrorMessage("");

       // parse to number once
    const numericValue = parseInt(value, 10);
    if (!value) return;

   if (
  numericValue < minValue ||
  numericValue > maxValue ||
  numericValue % minValue !== 0
) {
  setErrorMessage(
    `Please enter a valid amount between $${minValue} and $${maxValue}, in multiples of $${minValue}, based on your facility type.`
  );
} else {
  setErrorMessage("");
}

    


  };


 

  const handleConfirm = () => {
    // Check if the value is within the valid range
    if (rechargeAmount >= minValue && rechargeAmount <= maxValue) {
      setsubscribePlanType("topup");
    setsubscribePlanId(100)
    history.push("/payment-options", {
         data: {
           facilityOrSoberLivingId: id,
           topUpBudget:  rechargeAmount,
           redirectUrl:redirectUrl,
           houseType:facilityType
          
         },
       });
    } else {
      setErrorMessage(`Please enter a value between ${minValue} and ${maxValue}.`);
    }
  };

   const facilityCenter = [
    { value: "detox", label: "Detox" },
    { value: "residential", label: "Residential"},
    { value: "php", label: "PHP" },
    { value: "iop", label: "IOP" },
    { value: "sober", label: "Sober Living" },
  ];

  const facilityTypeValue = facilityCenter.find(facility => facility.value === facilityType)?.label || 'Sober Living';



  return (
    <div
      className="modal upgrade-plan cancel-subscription-modal fade show change-subscription"
      id="exampleModal"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="upgrade-plan-content top-up-recharge-content">
            <h3 className="modal-title">Ad Recharge</h3>
            <div className="recharge-wrapper">
              <span className="recharge-message">
                Please enter a recharge amount. $
              </span>
              <div className="input-container">
                <input
                  type="number"
                  value={rechargeAmount ?? ""}
                  onChange={handleChange}
                  onKeyPress={(e) => {
                    // Prevent decimal separator input
                    if ([".", ","].includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  min={minValue}
                  max={maxValue}
                  className="recharge-input"
                />
              </div>
            </div>
            {errorMessage && (
              <div className="error-message">{errorMessage}</div>
            )}
            <div className="recharge-note">
              <b>Note:</b>
              <br />
              • Minimum and maximum recharge limits apply based on your facility
              type:
              <br />
              · Sober Living: $2 – $100
              <br />
              · Residential: $9 – $450
              <br />
              · IOP / PHP / Detox: $5 – $250
              <br />
              <br />
              • The amount must be entered in multiples of the minimum value for
              your facility type.
              <br />
              (e.g., if your facility type is Detox, valid recharge amounts are
              5, 10, 15… up to 250)
              <br />• Each Ad view for {facilityTypeValue} facility is charged
              at ${minValue}.
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="modal-btn cancel-btn"
              onClick={onCancel}
            >
              Cancel
            </button>
            <button
              type="button"
              className={`modal-btn  ${
                rechargeAmount === "" || errorMessage !== ""
                  ? "disabled"
                  : "confirm-btn"
              }`}
              onClick={handleConfirm}
              disabled={rechargeAmount === "" || errorMessage !== ""}
            >
              Confirm
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopUpRechargeModel;
